 
// Config object to be passed to Msal on creation.
// For a full list of msal.js configuration parameters, 
// visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_authenticationparameters_.html
const msalConfig = {
    auth: {
      clientId: "b06cb1fc-6db7-4e55-bc77-d8abfb2fbd31",
      authority: "https://login.microsoftonline.com/common/",
      redirectUri: "http://localhost:8080/",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    request:{
      scopes: ["openid", "profile", "User.Read","People.Read","User.ReadBasic.All"]
    }
  };  
    
  // Add here scopes for id token to be used at MS Identity Platform endpoints.
 const loginRequest = {
    scopes: ["openid", "profile", "User.Read","People.Read","User.ReadBasic.All"]
  };
  
  // Add here scopes for access token to be used at MS Graph API endpoints.
  const tokenRequest = {
    scopes: ["Mail.Read","People.Read"]
  };

 export {msalConfig,loginRequest,tokenRequest} 